<template>
  <v-container fluid class="theme-color" style="height: auto;">
    <v-row class="card pb-4 mt-5" justify-space-between>
      <v-col cols="12">
        <Search @getSearchCondition="updateCondition" />
      </v-col>
    </v-row>
    <v-row class="card mt-4">
      <v-col cols="12">
        <AccidentGroup :searchCondition="condition" />
      </v-col>
    </v-row>
    <v-row class="card mt-4">
      <v-col cols="12">
        <AccidentTable :searchCondition="condition" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '../components/dashboard-water/Search.vue';
import AccidentTable from '../components/dashboard-water/AccidentTable.vue';
import AccidentGroup from '../components/dashboard-water/AccidentGroup';

export default {
  name: 'DashboardWater',
  components: {
    Search,
    AccidentTable,
    AccidentGroup
  },
  data: () => ({
    condition: null
  }),
  mounted() {
    this.$emit('sethambergervisible', false);
  },
  methods: {
    updateCondition(value) {
      this.condition = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 85% !important;
  background: none;
  margin: auto;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
